import { Loader } from '@myosh/odin-components';
import { useEffect, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { setUserLocale } from '../../../i18n';
import { useGetUserLocaleQuery } from '../../../redux/services/user';

interface UserLocaleInitializerProps {
  children: ReactNode;
}

export default function UserLocaleInitializer({ children }: UserLocaleInitializerProps) {
  const { t } = useTranslation();
  const [languageLoaded, setLanguageLoaded] = useState(false); // Only changing the language once on login

  const { data: useLocaleData, isLoading } = useGetUserLocaleQuery();

  useEffect(() => {
    if (languageLoaded) {
      return;
    } else if (useLocaleData?.localeCode && !isLoading) {
      setUserLocale(useLocaleData?.localeCode);
      setLanguageLoaded(true);
    } else if (!useLocaleData?.localeCode && !isLoading) {
      setLanguageLoaded(true); // No locale set for user, so we don't need to wait
    }
  }, [useLocaleData?.localeCode, isLoading]);

  if (!languageLoaded) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader title={t('loading-account-language')} />
      </div>
    );
  }

  return <>{children}</>;
}
